<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class='grid-wrap'>
        <dx-data-grid ref='refCarTypeGrid'
          :data-source='carTypeInfoList'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          :focused-row-enabled="true"
          :auto-navigate-to-focused-row="false"
          key-expr="모델코드"
          @row-removed='onRowRemoved'
          @row-inserted='onRowInserted'
          @row-updated='onRowUpdated'
          @row-updating="onUpdating"
          @init-new-row='onInitNewRow'
          @editor-preparing='onEditorPreparing'
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            file-name="고객사생산정보"
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxEditing
            :allow-deleting="true"
            :allow-updating="true"
            :allow-adding="true"
            :use-icons="true"
            mode='row'
          >
          </DxEditing>
          <DxColumn
            :allowEditing='true'
            caption="제조사"
            data-field="제조사"
            :visible='true'
          >
            <DxLookup
              :data-source="제조사Lookup"
              display-expr="코드명"
              value-expr="코드"
            />
            <dx-required-rule message="항목을 선택하세요"/>
          </DxColumn>
          <DxColumnFixing :enabled="true"/>
          <DxColumn
            :allowEditing='isIdEdit'
            caption="생산차종코드"
            data-field="모델코드"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='isIdEdit'
            caption="생산차종코드"
            data-field="모델코드"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="차종명"
            data-field="모델명"
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="양산차종"
            data-field="사용유무"
            :visible='true'
             >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="삭제유무"
            data-field="삭제유무"
            :visible='true'
             >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="등록일"
            data-field="createtime"
            dataType= 'date'
            format='yyyy-MM-dd'
             >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :visible='true'
            caption="수정일"
            data-field="updatetime"
            dataType= 'date'
            format='yyyy-MM-dd'
             >
          </DxColumn>

          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              show-in-column="발주사코드"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, {
  DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem, DxLookup,
  DxSummary, DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel } from 'devextreme-vue/data-grid'
import { DxRequiredRule } from 'devextreme-vue/validator'

export default {
  name: 'CarType',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '차종관리'
        }
      ],
      carTypeInfoList: null,
      companyInfoList: null,
      selectedCompanyCode: null,
      isIdEdit: true,
      customerLookup: null,
      제조사Lookup: null
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxSearchPanel,
    DxDataGrid,
    DxLookup,
    DxRequiredRule
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.제조사Lookup = this.$store.getters.getBaseDataByType(ConstDef.제조사)
    this.refreshCustomerLookup()
    this.refreshCarType()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onEditorPreparing (e) {
      if (e.dataField === '모델코드' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
      }
    },
    onInitNewRow (row) {
      row.data.사용유무 = true
      row.data.삭제유무 = false
    },
    onRowInserted (row) {
      row.data.updatetime = row.data.createtime = AppLib.getToday()
      row.data.updateid = row.data.createid = this.userInfo.userId
      this.$_sp.runInsertSqlProc('고객사생산품목', null, [row.data])
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
          this.$store.commit('saveCarType', this.carTypeInfoList)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowRemoved (row) {
      this.$_sp.runDeleteSqlProc('고객사생산품목', [{ 모델코드: row.data.모델코드, 발주사코드: row.data.발주사코드 }])
        .then((data) => {
          this.$snotify.info('삭제 되었습니다.')
          this.$store.commit('saveCarType', this.carTypeInfoList)
        })
    },
    onUpdating (row) {
    },
    onRowUpdated (row) {
      row.data.updatetime = AppLib.getNow()
      row.data.updateid = this.userInfo.userId
      this.$_sp.runUpdateSqlProc('고객사생산품목', ['모델코드', '발주사코드'], null, [row.data])
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
          this.$store.commit('saveCarType', this.carTypeInfoList)
        })
    },
    refreshCarType () {
      this.isLoading = true
      this.$_sp.runNoEncodeFindSqlProc('고객사생산품목', null)
        .then((data) => {
          this.carTypeInfoList = this.$_sp.MakeModel(data)
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshCustomerLookup () {
      this.$_sp.runNoEncodeFindSqlProc('거래처정보', { 거래처구분코드: '발주사' })
        .then((data) => {
          this.customerLookup = this.$_.sortBy(this.$_sp.MakeModel(data), '거래처명')
        })
    }
  }
}
</script>

<style lang="scss">

</style>
